/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
/* Generated: 2026-08-20T13:04:09.056Z */
import { makeUseModal } from '@/app/modals/helpers';

import type { AgeVerificationModalProps } from '@/features/age-verification/ui/AgeVerificationModal.modal';
import type { BuyBoinkersBoostModalProps } from '@/entities/market/ui/buy-boinkers-boost-modal/BuyBoinkersBoostModal.modal';
import type { BuyXpBoostModalProps } from '@/entities/leaderboards/ui/buy-xp-boost-modal/BuyXpBoostModal.modal';
import type { FifthDayNotificationModalProps } from '@/entities/task/ui/reward-notification-modal/FifthDayNotificationModal.modal';
import type { GrabLbPrizesModalProps } from '@/entities/leaderboards/ui/grab-lb-prizes-modal/GrabLbPrizesModal.modal';
import type { NewFeatureAlertModalProps } from '@/widgets/new-feature-alert/ui/new-feature-alert-modal/NewFeatureAlertModal.modal';
import type { NewUsersRefPageModalProps } from '@/pages/profile-page/ui/new-user-ref-modal/NewUsersRefPageModal.modal';
import type { NewXpModalProps } from '@/widgets/xp-modal/ui/NewXpModal.modal';
import type { OnboardingModal_R0Props } from '@/widgets/main-page/ui/modals/onboarding-modals/OnboardingModal_R0.modal';
import type { OnboardingModal_R1Props } from '@/widgets/main-page/ui/modals/onboarding-modals/OnboardingModal_R1.modal';
import type { OnboardingModal_R3Props } from '@/widgets/main-page/ui/modals/onboarding-modals/OnboardingModal_R3.modal';
import type { OnboardingModal_R5Props } from '@/widgets/main-page/ui/modals/onboarding-modals/OnboardingModal_R5.modal';
import type { OnboardingModal_R7Props } from '@/widgets/main-page/ui/modals/onboarding-modals/OnboardingModal_R7.modal';
import type { PlaycoinBoostModalProps } from '@/widgets/boost/ui/playcoin-boost-modal/PlaycoinBoostModal.modal';
import type { PlaydeckSubscriptionModalProps } from '@/widgets/playdeck-subscription-widget/playdeck-subscription-modal/PlaydeckSubscriptionModal.modal';
import type { PvpModalProps } from '@/features/pvp/ui/modal/PvpModal.modal';
import type { StateIoModalProps } from '@/entities/market/ui/state-io-modal/StateIoModal.modal';
import type { TenthDayNotificationModalProps } from '@/entities/task/ui/reward-notification-modal/TenthDayNotificationModal.modal';
import type { TopModalProps } from '@/widgets/main-page/ui/modals/top-modal/TopModal.modal';
import type { WalletBlockModalProps } from '@/widgets/wallet-block-modal/ui/WalletBlockModal.modal';
import type { Wheel100TonPrizeModalProps } from '@/entities/wheel/ui/wheel-100-ton-prize-modal/Wheel100TonPrizeModal.modal';
import type { WheelAdModalProps } from '@/entities/wheel/ui/wheel-ad-modal/WheelAdModal.modal';

import { ModalName } from './modals-names';

export const useAgeVerificationModal = makeUseModal<AgeVerificationModalProps>(
  ModalName.AgeVerificationModal
);
export const useBuyBoinkersBoostModal = makeUseModal<BuyBoinkersBoostModalProps>(
  ModalName.BuyBoinkersBoostModal
);
export const useBuyXpBoostModal = makeUseModal<BuyXpBoostModalProps>(
  ModalName.BuyXpBoostModal
);
export const useFifthDayNotificationModal = makeUseModal<FifthDayNotificationModalProps>(
  ModalName.FifthDayNotificationModal
);
export const useGrabLbPrizesModal = makeUseModal<GrabLbPrizesModalProps>(
  ModalName.GrabLbPrizesModal
);
export const useNewFeatureAlertModal = makeUseModal<NewFeatureAlertModalProps>(
  ModalName.NewFeatureAlertModal
);
export const useNewUsersRefPageModal = makeUseModal<NewUsersRefPageModalProps>(
  ModalName.NewUsersRefPageModal
);
export const useNewXpModal = makeUseModal<NewXpModalProps>(ModalName.NewXpModal);
export const useOnboardingModal_R0 = makeUseModal<OnboardingModal_R0Props>(
  ModalName.OnboardingModal_R0
);
export const useOnboardingModal_R1 = makeUseModal<OnboardingModal_R1Props>(
  ModalName.OnboardingModal_R1
);
export const useOnboardingModal_R3 = makeUseModal<OnboardingModal_R3Props>(
  ModalName.OnboardingModal_R3
);
export const useOnboardingModal_R5 = makeUseModal<OnboardingModal_R5Props>(
  ModalName.OnboardingModal_R5
);
export const useOnboardingModal_R7 = makeUseModal<OnboardingModal_R7Props>(
  ModalName.OnboardingModal_R7
);
export const usePlaycoinBoostModal = makeUseModal<PlaycoinBoostModalProps>(
  ModalName.PlaycoinBoostModal
);
export const usePlaydeckSubscriptionModal = makeUseModal<PlaydeckSubscriptionModalProps>(
  ModalName.PlaydeckSubscriptionModal
);
export const usePvpModal = makeUseModal<PvpModalProps>(ModalName.PvpModal);
export const useStateIoModal = makeUseModal<StateIoModalProps>(ModalName.StateIoModal);
export const useTenthDayNotificationModal = makeUseModal<TenthDayNotificationModalProps>(
  ModalName.TenthDayNotificationModal
);
export const useTopModal = makeUseModal<TopModalProps>(ModalName.TopModal);
export const useWalletBlockModal = makeUseModal<WalletBlockModalProps>(
  ModalName.WalletBlockModal
);
export const useWheel100TonPrizeModal = makeUseModal<Wheel100TonPrizeModalProps>(
  ModalName.Wheel100TonPrizeModal
);
export const useWheelAdModal = makeUseModal<WheelAdModalProps>(ModalName.WheelAdModal);
